module.exports = __webpack_public_path__ + "img/title_partners@2x.df6bfb83.png";